import { render, staticRenderFns } from "./custom-token.vue?vue&type=template&id=59ca8780&"
import script from "./custom-token.vue?vue&type=script&lang=ts&"
export * from "./custom-token.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports